import React from "react";
import { Modal, ModalBody } from "reactstrap";

const PopupModal = ({ isOpen, message, backgroundColor, image, onClose }) => {
  const accent = backgroundColor || "#4a6cde";
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop={false}
      style={{
        position: "fixed",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "auto",
        zIndex: 20000,
        pointerEvents: "none",
      }}
      contentClassName="border-0 shadow-none bg-transparent"
    >
      <ModalBody
        style={{
          background:
            "linear-gradient(135deg, rgba(42, 49, 67, 0.98) 0%, rgba(26, 31, 44, 0.98) 100%)",
          color: "#e5ecff",
          border: `2px solid ${accent}`,
          borderRadius: "8px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
          textAlign: "center",
          padding: "15px",
          pointerEvents: "auto",
        }}
      >
        {image && (
          <img
            src={image}
            alt="Popup"
            style={{ width: "40px", marginBottom: "10px" }}
          />
        )}
        <div>{message}</div>
      </ModalBody>
    </Modal>
  );
};

export default PopupModal;
